import React, { useEffect, useRef } from 'react';

const AnimatedSection = () => {
  const animatedSectionRef = useRef(null);

  useEffect(() => {
    const animatedSection = animatedSectionRef.current;

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        // Check if the entry is fully in view
        if (entry.isIntersecting && entry.intersectionRatio === 1) {
          animatedSection.classList.add("visible");
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 1 }); // Set threshold to 1 for 100% visibility

    observer.observe(animatedSection);

    // Cleanup when the component unmounts
    return () => observer.disconnect();
  }, []); // Empty dependency array to run this effect once on mount

  return (
    <>
      
      
      <div ref={animatedSectionRef} className="alerts slide-left-text">
        Alerts!
      </div>
    </>
  );
}

export default AnimatedSection;
